var path = '/_common/directives/ifastAutoComplete/ifastAutoCompleteResultsSlsRep.tpl.html';
var html = "<div ifast-panel ifast-object-id=SlsRepSrchResult panelid=salesRepSearchResults paneltype=modal panelpinned=false disableloadevent=true class=\"ifast-advisor ifast-modal\"> <div ifast-grid ifast-object-id=SlsRepSrchResult ifast-options=iFastAutoCompleteResultsController.gridSearch ifast-toolbar-template=slsRepSearchFilterTemplate ifast-local-data=iFastAutoCompleteResultsController.localData class=\"ifds-search-results ifds-advanceQueryFilter\"> </div> </div> ";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./WebContent/src/_common/directives/ifastAutoComplete/ifastAutoCompleteResultsSlsRep.tpl.html
// module id = 769
// module chunks = 0 2